module.exports = __webpack_public_path__ + "static/media/3-wap.c79012ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageUrlSec/3-wap.png
// module id = 574
// module chunks = 0